import { AddCapacityField } from './AddCapacityField';

export default AddCapacityField;
